 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~e2e93592": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~e2e93592": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","home~537d1784":"home~537d1784","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"6ab2d98a","chunk-19b0cf18":"3066a2c5","chunk-1ef999a0":"985aa04d","chunk-2710fcfb":"e8e62400","chunk-2d0aab45":"c4f0b21b","chunk-2d0b6737":"2587b38a","chunk-2d0cc1d9":"e13457ca","chunk-2d0dd612":"8ae87b54","chunk-2fd16595":"e7476863","chunk-3d370fbd":"0ea89679","chunk-40377910":"1a53eb39","chunk-4fc4313d":"bc8e8b94","chunk-5069aa76":"70a0bf68","chunk-6cf3788a":"c88b61c3","chunk-7b86735e":"64a42869","chunk-commons~d939e436":"ab91f5c1","chunk-commons~f71cff67":"d96208c7","chunk-commons~21833f8f":"9fa787fa","chunk-0ae04c33":"e13532ac","chunk-1645f56e":"75ff34c4","chunk-1866c8c3":"83661476","chunk-1b248aa2":"2c90d91d","chunk-22ceca5e":"96158a95","chunk-278f15c2":"c1b88ae3","chunk-2d0a30ec":"0e5b0641","chunk-2d0c917a":"cbdc5028","chunk-2d0da362":"8712b745","chunk-2d0daf52":"8a7fd38e","chunk-2d0e4810":"3d001dcb","chunk-2d0efccf":"cbf3ce32","chunk-2d207d1a":"f9bac101","chunk-2d2140d8":"485f6d81","chunk-2d217776":"74c2b71a","chunk-2d226c7a":"1d767631","chunk-35669c0e":"48465ad5","chunk-45a5ce10":"db3620be","chunk-4962705e":"4b2a5bd7","chunk-65efcd1a":"0528947a","chunk-693a6ee4":"8ea4d285","chunk-89355420":"f1f582c9","chunk-ab48b786":"fbd30fcf","chunk-b8d1fc08":"6ff64837","chunk-f5c05406":"e2404794","chunk-f87666b8":"44429457","home~537d1784":"678e7108","sentiment~21833f8f":"e9853c78","user~6e76d53f":"697ece17","chunk-ef584cd2":"8e3bacd3","chunk-58adf2a4":"38a43604"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05a29214":1,"chunk-19b0cf18":1,"chunk-1ef999a0":1,"chunk-2710fcfb":1,"chunk-3d370fbd":1,"chunk-40377910":1,"chunk-4fc4313d":1,"chunk-6cf3788a":1,"chunk-7b86735e":1,"chunk-commons~f71cff67":1,"chunk-commons~21833f8f":1,"chunk-0ae04c33":1,"chunk-1645f56e":1,"chunk-1866c8c3":1,"chunk-1b248aa2":1,"chunk-22ceca5e":1,"chunk-278f15c2":1,"chunk-35669c0e":1,"chunk-45a5ce10":1,"chunk-4962705e":1,"chunk-65efcd1a":1,"chunk-693a6ee4":1,"chunk-89355420":1,"chunk-ab48b786":1,"chunk-b8d1fc08":1,"chunk-f5c05406":1,"chunk-f87666b8":1,"home~537d1784":1,"user~6e76d53f":1,"chunk-ef584cd2":1,"chunk-58adf2a4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~d939e436":"chunk-commons~d939e436","chunk-commons~f71cff67":"chunk-commons~f71cff67","chunk-commons~21833f8f":"chunk-commons~21833f8f","home~537d1784":"home~537d1784","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f"}[chunkId]||chunkId) + "." + {"chunk-05a29214":"20d2b46c","chunk-19b0cf18":"3a86a2cb","chunk-1ef999a0":"d8857b04","chunk-2710fcfb":"f823ba86","chunk-2d0aab45":"31d6cfe0","chunk-2d0b6737":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2d0dd612":"31d6cfe0","chunk-2fd16595":"31d6cfe0","chunk-3d370fbd":"064cab12","chunk-40377910":"5e49fa7a","chunk-4fc4313d":"80994280","chunk-5069aa76":"31d6cfe0","chunk-6cf3788a":"96798e3f","chunk-7b86735e":"910a6f12","chunk-commons~d939e436":"31d6cfe0","chunk-commons~f71cff67":"343f72d6","chunk-commons~21833f8f":"dfbce4cc","chunk-0ae04c33":"28cf586b","chunk-1645f56e":"a819acc9","chunk-1866c8c3":"43d684f4","chunk-1b248aa2":"cad0d605","chunk-22ceca5e":"8127b904","chunk-278f15c2":"5c5c2664","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-35669c0e":"4c4de6e1","chunk-45a5ce10":"ca4046b3","chunk-4962705e":"35010b62","chunk-65efcd1a":"9b96fbd4","chunk-693a6ee4":"ab709dd2","chunk-89355420":"87278ac5","chunk-ab48b786":"1463a986","chunk-b8d1fc08":"105a6a10","chunk-f5c05406":"4ed08d7c","chunk-f87666b8":"76b069b8","home~537d1784":"5f03273a","sentiment~21833f8f":"31d6cfe0","user~6e76d53f":"58a80247","chunk-ef584cd2":"c7f95f68","chunk-58adf2a4":"ae727cbf"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~d939e436"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
